<template>
    <slot
        :entries
        :status
    />
</template>

<script setup lang="ts">
import query from '~/graphql/queries/Collections.graphql';
import type { RelatedToCategoriesFilter } from '~/types/bundle';
import type { CollectionsQuery as CollectionsQueryType, CollectionCardFragment } from '~/types/craft-schema';

const {
    collectionTypeId = null,
    relatedToCategories = null,
} = defineProps<{
    collectionTypeId?: string | null;
    relatedToCategories?: RelatedToCategoriesFilter[] | null;
}>();

const variables = computed(() => ({
    collectionTypeId,
    relatedToCategories,
}));

const { data, status } = await useAsyncQuery<CollectionsQueryType>({ query, variables });

const entries = computed(() => data.value?.entries as CollectionCardFragment[] | undefined);
</script>

